import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { DashboardFacade } from '@cigna/chcp/dashboard/data-access';

import {
  User,
  TinAccess,
} from '@cigna/chcp/working-with-cigna/manage-access-feature';
import { ManageAccessViewUserDialogComponent } from '../manage-access-view-user-dialog/manage-access-view-user-dialog.component';

@Component({
  selector: 'cigna-manage-access-tile',
  templateUrl: './manage-access-tile.component.html',
  styleUrls: ['./manage-access-tile.component.scss', '../tile.scss'],
})
export class ManageAccessTileComponent {
  dashboardData$ = this.dashboardFacade.manageAcccessDashboardData$;

  checkedUsers: string[] = [];

  constructor(
    private dashboardFacade: DashboardFacade,
    public dialog: MatDialog,
    private router: Router,
  ) {}

  renderTins(tins: TinAccess[]) {
    return tins.filter((tin) => tin.status === 'un assigned');
  }

  onUserCheck(userId: string, event: Event) {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      this.checkedUsers.push(userId);
    } else {
      this.checkedUsers = this.checkedUsers.filter((u) => u !== userId);
    }
  }

  onModifySelectedUsers(): void {
    this.editUsers(this.checkedUsers);
  }

  viewUserDetail(user: User) {
    const dialogRef = this.dialog.open(ManageAccessViewUserDialogComponent, {
      data: {
        user,
        isLoading: true,
        impersonator: false,
      },
      autoFocus: false,
      width: '800px',
    });

    dialogRef.componentInstance.editIndividualUser.subscribe(() => {
      this.editUsers([user.id]);
      dialogRef.close();
    });
  }

  editUsers(users: string[]) {
    this.router.navigate(['/my-practice/manage-access/assignment-method'], {
      queryParams: { users: users.join(',') },
    });
  }

  get modifyButtonEnabled() {
    return this.checkedUsers.length > 0;
  }
}
